import React, { useState, useEffect } from 'react';
import { RootState, useAppDispatch, useAppSelector } from '../../redux';
import { getGeneralDashboardUrl, getProjectDashboardUrl } from '../../redux';
import { Project } from '../../models';
import { Metabase } from '../../services';
import { Loader }  from '..';

interface MetabaseDashboardProps {
    project?: Project;
}

function MetabaseDashboard(props: MetabaseDashboardProps) {
    const { project } = props;
    const dispatch    = useAppDispatch();

    const [visible, showIframe] = useState(false);

    const { projectId, generalDashboard, projectDashboard } = useAppSelector((state: RootState) => state.metabase);

    useEffect(() => {
        if (project?._id)
            dispatch(getProjectDashboardUrl(project._id));
        else
            dispatch(getGeneralDashboardUrl());
    }, [dispatch, project?._id]);

    const onLoad = () => {
        setTimeout(() => {
            showIframe(true);
        }, 500);
    }

    if (project && (!projectDashboard || (projectId !== project?._id)))
        return null;

    if (!project && !generalDashboard)
        return null;

    return (
        <div className="p-3">
            {!visible && <Loader />}
            <iframe
                src={ project ? projectDashboard : generalDashboard }
                frameBorder="0"
                width="100%"
                height="1200"
                onLoad={onLoad}
                allowTransparency
                style={{ display: visible ? 'block' : 'none' }}
                title="Dashboard"
            />
        </div>
    );
}

export default MetabaseDashboard;
